import { ColliEnumClient } from '@frontend/colli/api';
import { ColliState, ColliStateName } from '@frontend/colli/types';
import { useEffect, useState } from 'react';

import { SelectOption } from '@frontend/components/basic-forms';
import { ColliStateSelectProps } from '././colli-state-select.component';

interface ViewProps {
    options: SelectOption<ColliStateName>[];
}

const useColliStateSelect = (props: ColliStateSelectProps): ViewProps => {
    const [options, changeOptions] = useState<SelectOption<ColliStateName>[]>([]);

    useEffect(() => {
        ColliEnumClient.fetchColliStates().then((states) => {
            return changeOptions(
                states.filter((state) => props.subset ? props.subset.includes(state) : true).map((state) => {
                    const found = ColliState.ALL.find((t) => t.value === state);
                    if (found) {
                        return {
                            value: found.value,
                            label: found.value,
                            display: found.displayName
                        };
                    } else return {
                        value: state,
                        label: state.replace(/_/g, ' ')
                    };
                })
            );
        });
    }, []);

    return { options };
};

export default useColliStateSelect;
